


























import { TypeComponentNoti } from "@/enums/enums";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AlertStore = namespace("Alert");

@Component
export default class AlertComponent extends Vue {
  private TypeComponentNoti = TypeComponentNoti;
  private options: any = {};
  private array: any = [];
  private timer: any = {};
  private errorMessage: any = "";

  @AlertStore.Getter
  private getAlertMessage!: any;

  @Watch("getAlertMessage", { deep: true })
  getAlertMessageChanged() {
    this.options = this.getAlertMessage;
    this.GetPeakExceptionMessage();
  }
  @Watch("options", { deep: true })
  optionsChanged() {
    if (this.options.typeUpload == "Start") {
      const id = this.options.id;
      this.array.push({
        message: "กำลังอัปโหลด",
        type: this.options.type,
        progress: 0,
        id: id,
      });
      this.SetProgress(id);
    } else if (this.options.typeUpload == "End") {
      clearInterval(this.options.id);
      this.array.forEach((element: any) => {
        if (element.id == this.options.id) {
          element.message = this.options.message;
          element.type = this.options.type;
        }
      });
      this.StartTimer(this.options.id);
    } else if (this.options.message) {
      const id = this.setIdNoti(this.options.date);
      this.array.push({
        message: this.options.message,
        type: this.options.type,
        name: this.typeName(this.options.type),
        class: this.typeClass(this.options.type),
        id: id,
      });

      this.StartTimer(id);
    }
  }

  public SetProgress(id: any) {
    let progress = 0;

    const frame = () => {
      if (progress >= 95) {
        clearInterval(id);
      } else {
        progress++;
        this.array.forEach((element: any) => {
          if (element.id === this.options.id) {
            element.progress = progress;
          }
        });
      }
    };

    id = setInterval(frame, 27); // 0 - 95 ใน 2.5 วินาที
  }

  public setIdNoti(date: any) {
    return `${date.getDay()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}${date.getMilliseconds()}`;
  }
  public typeClass(type: any) {
    let classType = "";
    switch (type) {
      case TypeComponentNoti.Success:
        classType = "success";
        break;
      case TypeComponentNoti.Warn:
        classType = "warn";
        break;
      case TypeComponentNoti.Error:
        classType = "error";
        break;
      case TypeComponentNoti.Upload:
        classType = "upload";
        break;
    }
    return classType;
  }

  public typeName(type: any) {
    let aletStr = "";
    switch (type) {
      case TypeComponentNoti.Success:
        aletStr = "สำเร็จ";
        break;
      case TypeComponentNoti.Warn:
        aletStr = "แจ้งเตือน";
        break;
      case TypeComponentNoti.Error:
        aletStr = "ผิดพลาด";
        break;
    }
    return aletStr;
  }

  public remove(id: any) {
    this.array.forEach((item: any, index: number) => {
      if (id == item.id) {
        this.array.splice(index, 1);
      }
    });

    delete this.timer[id];
  }
  public StopTimer(id: any) {
    clearTimeout(this.timer[id]);
    delete this.timer[id];
  }
  public StartTimer(id: any) {
    this.timer[id] = setTimeout(() => {
      this.remove(id);
    }, 5000);
  }

  public GetPeakExceptionMessage() {
    if (this.options.peakExceptionResponseCode == 41) {
      this.options.message = this.$t("PeakExceptionCode_41");
    }
  }
}
